<div *nzModalTitle>
  <span>{{ 'LOT_BIDDING_MODAL.PLACE_YOUR_BID' | translate }}</span>
  <button
    *ngIf="tradingOpen$ | async"
    class="guide-btn"
    nz-tooltip
    [nzTooltipTitle]="'HINT' | translate"
    nzTooltipPlacement="right"
    nz-button
    nzType="default"
    nzShape="circle"
    (click)="startGuide()"
  >
    <span nz-icon nzType="question-circle" nzTheme="outline"></span>
  </button>
</div>

<nz-alert
  class="negotiations-notice"
  *ngIf="tradingClosed$ | async"
  nzType="warning"
  nzShowIcon
  [nzMessage]="'NEGOTIATIONS.TRADING_CLOSED' | translate"
></nz-alert>

<nz-spin
  *ngIf="tradingOpen$ | async"
  nzSize="large"
  [nzSpinning]="(limits.loading$ | async) || (biddingDataQueryRef.loading | async)"
>
  <main>
    <app-alerts-list-manual
      class="alerts-list-manual"
      *ngIf="(biddingDataQueryRef.data | async)?.alerts?.length"
      [alerts]="(biddingDataQueryRef.data | async)?.alerts"
    ></app-alerts-list-manual>
    <nz-alert
      nzShowIcon
      nzType="warning"
      *ngIf="bidMayNotBeProcessed"
      [nzMessage]="'BID_MAY_NOT_BID_PROCESSED' | translate"
    ></nz-alert>
    <nz-alert
      nzType="warning"
      nzShowIcon
      *ngIf="withLimitsOverride"
      nzMessage="Дополнительная комиссия 1% стоимости лота (не менее 10 000 йен)"
    ></nz-alert>
    <nz-alert
      *ngIf="limits.canPalaceOnlyOneBid$ | async"
      nzType="warning"
      nzShowIcon
      [nzMessage]="'LOT_BIDDING_MODAL.CAN_PACE_ONLY_ONE_BID' | translate"
    ></nz-alert>

    <nz-alert
      class="negotiations-notice"
      *ngIf="lot.tradingClosureBiddingEndsAt"
      nzType="warning"
      nzShowIcon
      [nzMessage]="
        'NEGOTIATIONS.TRADING_DEADLINE'
          | translate: { date: biddingDeadlineTime | date: 'yyyy-MM-dd HH:mm':'+0900' }
      "
    ></nz-alert>

    <nz-alert
      class="negotiations-notice"
      *ngIf="isFirstNegotiationsBid"
      nzType="info"
      nzShowIcon
      [nzMessage]="
        'NEGOTIATIONS.FIRST_BID'
          | translate: { amount: negotiationsMinimum | currency: 'JPY':'symbol-narrow':'1.0-0' }
      "
    ></nz-alert>
    <form nz-form [formGroup]="form">
      <nz-alert
        *ngIf="isHighImportDutyLot$ | async"
        nzType="warning"
        [nzMessage]="'LOT_BIDDING_MODAL.HIGHT_IMPORT_DUTY' | translate"
      ></nz-alert>
      <app-max-bid-amount-alert
        [maxBidAmountLimit]="(biddingDataQueryRef.data | async)?.currentUser?.maxBidAmountLimit"
      ></app-max-bid-amount-alert>
      <nz-form-item [nzGutter]="[3, 0]">
        <nz-form-control>
          <nz-input-number
            class="w-100"
            id="0"
            type="text"
            #nzInputNumber
            formControlName="amount"
            nzPlaceHolder="{{ 'LOT_BIDDING_MODAL.YOUR_BID' | translate }}"
            [nzMin]="0"
            [nzStep]="10000"
            [nzParser]="parserYen"
            [nzFormatter]="formatterYen"
            (nzFocus)="nzInputNumber.inputElement.nativeElement.select()"
            appGuideAnchor="bid-amount"
          ></nz-input-number>
          <app-bid-amount-score
            *ngIf="form.value.amount > 0 && lot?.frame"
            [lot]="lot"
            [amount]="form.value.amount"
            (bidMakeSense)="this.bidMakeSenseChange$.next($event)"
          ></app-bid-amount-score>
        </nz-form-control>

        <div
          id="groupBids2"
          class="ant-form-item-control pos-relative"
          appGuideAnchor="group-container"
        >
          <nz-form-control
            *ngIf="!isNewGroup && (biddingDataQueryRef.data | async)?.isCanGroupBids"
          >
            <nz-input-group class="d-flex" nzCompact>
              <nz-select
                id="newGroupBids"
                *ngIf="(biddingDataQueryRef.data | async)?.bidGroups?.length"
                formControlName="groupId"
                style="width: 90%"
                nzPlaceHolder="{{ 'LOT_BIDDING_MODAL.NO_GROUP' | translate }}"
              >
                <nz-option
                  [nzValue]="''"
                  nzLabel="{{ 'LOT_BIDDING_MODAL.NO_GROUP' | translate }}"
                ></nz-option>
                <nz-option
                  *ngFor="let group of (biddingDataQueryRef.data | async)?.bidGroups"
                  [nzValue]="group.id"
                  [nzLabel]="getBidGroupLabel(group)"
                  [nzDisabled]="group.lotsLimitReached && !currentUserLastBid"
                ></nz-option>
              </nz-select>
              <button
                appGuideAnchor="create-group"
                nz-button
                nzBlock
                type="button"
                nzType="primary"
                (click)="createNewGroup($event)"
              >
                {{ 'LOT_BIDDING_MODAL.NEW_GROUP' | translate }}
              </button>
            </nz-input-group>
          </nz-form-control>

          <nz-form-control
            class="pos-relative"
            *ngIf="isNewGroup && (biddingDataQueryRef.data | async)?.isCanGroupBids"
            formGroupName="newGroup"
          >
            <nz-input-group class="d-flex" nzCompact>
              <nz-select style="width: 50%" formControlName="letter" nzPlaceHolder="Letter">
                <nz-option
                  *ngFor="let letter of (biddingDataQueryRef.data | async)?.allowedLetters"
                  [nzValue]="letter"
                  [nzLabel]="letter"
                ></nz-option>
              </nz-select>
              <nz-input-number
                type="text"
                id="quantity"
                [nzMin]="1"
                [nzMax]="9"
                nzPlaceHolder="{{ 'LOT_BIDDING_MODAL.QUANTITY' | translate }}"
                formControlName="quantity"
              ></nz-input-number>
            </nz-input-group>
          </nz-form-control>
          <button
            [ngClass]="{
              hide: !(isNewGroup && (biddingDataQueryRef.data | async)?.isCanGroupBids)
            }"
            id="removeNewGroup"
            appGuideAnchor="remove-group"
            nz-button
            type="button"
            nzType="primary"
            nzDanger
            (click)="removeNewGroup({ guideTarget: 'afterGrouping' }, $event)"
          >
            <i nz-icon nzType="close" nzTheme="outline"></i>
          </button>
        </div>
      </nz-form-item>

      <app-commission-agreement-control
        [lot]="lot"
        [amount]="form.value.amount"
        [maxBidAmount]="(biddingDataQueryRef.data | async)?.maxBidAmount"
        [minBidCommission]="(biddingDataQueryRef.data | async)?.minBidCommission"
        [isOtherCountriesUser]="(biddingDataQueryRef.data | async)?.currentUser?.isOtherCountries"
        (maxAmountReached)="maxBidLimitReached$.next($event)"
        formControlName="commissionAgreement"
      ></app-commission-agreement-control>

      <lib-minimal-jp-calculator
        id="5"
        *ngIf="
          renderCalculator && !(biddingDataQueryRef.data | async)?.currentUser?.isOtherCountries
        "
        appGuideAnchor="minimal-jp-calculator"
        [amount]="form.value.amount"
        [auctionId]="(biddingDataQueryRef.data | async)?.auction?.id"
        [lotType]="lotType"
      ></lib-minimal-jp-calculator>

      <div *ngIf="!((biddingDataQueryRef.data | async)?.isCanGroupBids ?? true)">
        {{ 'LOT_BIDDING_MODAL.TENDER_AUCTION_NO_GROUP' | translate }}
      </div>

      <nz-form-item>
        <nz-form-control>
          <app-bid-condition-selector
            appGuideAnchor="condition"
            id="6"
            formControlName="conditionId"
            [isRussianClient]="
              (biddingDataQueryRef.data | async)?.currentUser?.countryIso?.toLowerCase() === 'ru'
            "
            [conditions]="(biddingDataQueryRef.data | async)?.conditions"
            (disassemblyStateChange)="setDisassemblyState($event)"
          ></app-bid-condition-selector>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="canOrderPriorityPass$ | async">
        <nz-form-control>
          <div>
            <nz-radio-group formControlName="needPriorityPass" nzButtonStyle="solid">
              <label nz-radio-button [nzValue]="false">
                {{ 'LOT_BIDDING_MODAL.DEFAULT_DELIVERY' | translate }}
              </label>
              <label nz-radio-button [nzValue]="true">
                {{ 'LOT_BIDDING_MODAL.PRIORITY_PASS' | translate }}
              </label>
            </nz-radio-group>
            <a
              nz-button
              nzType="link"
              class="priority-pass-info-button"
              (click)="openPriorityPassInfoModal()"
            >
              <i nz-icon nzType="question-circle" nzTheme="outline"></i>
            </a>
          </div>
          <div *ngIf="form.value.needPriorityPass">
            ~1000 USD (<a (click)="openPriorityPassInfoModal()">{{ 'DETAILS' | translate }}</a
            >)
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <nz-input-group>
            <textarea
              id="7"
              appGuideAnchor="comment"
              formControlName="comment"
              nz-input
              rows="2"
              placeholder="{{ 'LOT_BIDDING_MODAL.YOUR_COMMENT' | translate }}"
            ></textarea>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-alert
        *ngIf="bidDelete1100prohibited"
        nzType="warning"
        nzShowIcon
        class="w-100"
        [nzMessage]="message1100"
      ></nz-alert>
      <nz-alert
        *ngIf="bidDelete1700prohibited"
        nzType="warning"
        nzShowIcon
        class="w-100"
        [nzMessage]="message1700"
      ></nz-alert>
      <ng-template #message1100>
        <p class="message-1100">
          {{ 'BID_DELETE_PROHIBITED_1100' | translate }}
          {{ 'LOT_BIDDING_MODAL.IN_ACCORDANCE_WITH' | translate }}
          <a target="_blank" href="https://ecarjp.com/article/bid-rules">
            {{ 'LOT_BIDDING_MODAL.BID_RULES' | translate }}
          </a>
        </p>
      </ng-template>
      <ng-template #message1700>
        <p class="message-1700">
          {{ 'BID_DELETE_PROHIBITED_1700' | translate }}
          {{ 'LOT_BIDDING_MODAL.IN_ACCORDANCE_WITH' | translate }}
          <a target="_blank" href="https://ecarjp.com/article/bid-rules">
            {{ 'LOT_BIDDING_MODAL.BID_RULES' | translate }}
          </a>
        </p>
      </ng-template>

      <nz-form-item class="mb-5">
        <nz-form-control *ngIf="!(biddingDataQueryRef.data | async)?.isSanctioned">
          <div id="createTranslation9" appGuideAnchor="create-translation-hint">
            <label
              id="8"
              appGuideAnchor="create-translation"
              nz-checkbox
              formControlName="createTranslation"
            >
              {{ 'LOT_BIDDING_MODAL.TRANSLATE_REQUEST' | translate }}
              <button nz-button nzType="link" (click)="notificationSettings()">
                <span style="text-decoration: underline">
                  {{ (this.queryRef.data | async)?.currentUser?.preferredLang | uppercase }}
                  <span
                    *ngIf="(this.queryRef.data | async)?.currentUser?.defaultTranslationMediaType"
                  >
                    ({{
                      'TRANSLATION_SETTINGS.TRANSLATION_MEDIA_TYPES.' +
                        (this.queryRef.data | async)?.currentUser?.defaultTranslationMediaType
                        | uppercase
                        | translate
                    }})
                  </span>
                </span>
              </button>
            </label>

            <ng-container *ngIf="form.get('createTranslation')?.value">
              <nz-tag nzColor="blue" class="translate-warn-tag">
                {{ 'LOT_BIDDING_MODAL.TRANSLATE_CONFIRMATION_TEXT' | translate }}
              </nz-tag>
            </ng-container>
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="mb-5">
        <nz-form-control [nzSpan]="24" nz-row>
          <nz-row nzAlign="middle">
            <label appGuideAnchor="notify-result" id="10" nz-checkbox formControlName="notify">
              {{ 'LOT_BIDDING_MODAL.NOTIFY_REQUEST' | translate }}
            </label>
            <div
              class="d-flex"
              nz-tooltip
              [nzTooltipTitle]="'LOT_BIDDING_MODAL.NOTIFY_REQUEST_TOOLTIP' | translate"
              nzTooltipPlacement="right"
            >
              <span
                style="font-size: 22px"
                nz-icon
                nzType="question-circle"
                nzTheme="outline"
              ></span>
            </div>
          </nz-row>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="mb-5">
        <nz-form-control>
          <label appGuideAnchor="bid-rules" id="11" nz-checkbox formControlName="agreement">
            {{ 'LOT_BIDDING_MODAL.AGREEMENT_HINT1' | translate }}
            <a
              target="_blank"
              (click)="$event.stopPropagation()"
              style="color: red"
              href="https://ecarjp.com/article/bid-rules"
            >
              {{ 'LOT_BIDDING_MODAL.BID_RULES' | translate }}
            </a>
            {{ 'LOT_BIDDING_MODAL.AGREEMENT_HINT2' | translate }}
          </label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="mb-5">
        <nz-form-control *ngIf="isDisassembly">
          {{ 'LOT_BIDDING_MODAL.NAVIS_RULES_HINT1' | translate }}
          <span class="color-red pointer" (click)="showNavisRules()">
            {{ 'LOT_BIDDING_MODAL.NAVIS_RULES_HINT2' | translate }}.
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item
        class="mb-5"
        *ngIf="['ru', 'RU'].includes((queryRef.data | async)?.currentUser?.countryIso)"
      >
        <nz-form-control [nzSpan]="24">
          <app-green-corner-switch
            appGuideAnchor="green-corner"
            [lot]="lot"
            [lotType]="lotType"
            [amount]="form.value.amount"
            [bidConditionId]="form.value.conditionId"
            id="12"
            formControlName="isGreenCorner"
          ></app-green-corner-switch>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="mb-10" *ngIf="form?.value?.conditionId === SPECIAL_EQUIPMENT_ID">
        <nz-alert
          class="w-100"
          nzType="warning"
          [nzMessage]="
            'VAT'
              | translate
                : {
                    price: (form?.value?.amount || 0) * 0.1 | currency: 'JPY':'symbol-narrow'
                  }
          "
          nzShowIcon
        >
        </nz-alert>
      </nz-form-item>
    </form>

    <div class="time-remaining-container">
      <nz-row nzJustify="space-between" nzAlign="middle">
        <nz-col>
          {{ 'LOT_BIDDING_MODAL.TIME_REMAINING' | translate }}
          ({{ lot.time | date: 'yyyy-MM-dd HH:mm':'+0900' }})
        </nz-col>
        <nz-col>
          <div *ngIf="isActiveLot$ | async">
            <span class="time-left">{{ 'LOT_BIDDING_MODAL.TIME_LEFT' | translate }}</span>
            <nz-countdown
              [nzValue]="deadlineLotTime"
              [class.red-countdown]="isEndSoon$ | async"
            ></nz-countdown>
          </div>

          <strong *ngIf="(isActiveLot$ | async) === false" class="end-soon-text">
            {{ 'LOT_INFO.BIDDING_OVER' | translate }}
          </strong>
        </nz-col>
      </nz-row>
    </div>
  </main>
</nz-spin>

<footer *nzModalFooter>
  <button nz-button (click)="modal.close()" [disabled]="isPlacingBid$ | async">
    {{ 'CANCEL' | translate }}
  </button>

  <button
    *ngIf="tradingOpen$ | async"
    nz-button
    nz-popconfirm
    nzType="primary"
    [class.is-green-corner]="form.value.isGreenCorner"
    [nzLoading]="isPlacingBid$ | async"
    [disabled]="submitDisabled$ | async"
    [nzPopconfirmTitle]="placeBidConfirmation"
    [nzPopconfirmOverlayStyle]="{ 'max-width': '300px' }"
    [nzCondition]="placeConfirmationNotNeed$ | async"
    [nzOkText]="'LOT_BIDDING_MODAL.PLACE_YOUR_BID' | translate"
    (nzOnConfirm)="checkBirthdateAndPlaceBid()"
  >
    <ng-template #placeBidConfirmation>
      <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
      <div class="ant-popover-message-title">
        <div *ngIf="(bidMakeSense$ | async) === false">
          {{ 'LOT_BIDDING_MODAL.DOESNT_MAKE_SENSE' | translate }}
        </div>
        <div *ngIf="limits.canPalaceOnlyOneBid$ | async">
          {{ 'LOT_BIDDING_MODAL.CAN_PACE_ONLY_ONE_BID' | translate }}
          {{ 'LOT_BIDDING_MODAL.WANT_PLACE_BID' | translate }}
        </div>
        <div *ngIf="isSanctionedUtilization$ | async">
          {{ 'LOT_BIDDING_MODAL.IS_SANCTIONED_UTILIZATION_SURE' | translate }}
        </div>
      </div>
    </ng-template>
    {{ 'LOT_BIDDING_MODAL.PLACE_YOUR_BID' | translate }}
  </button>
</footer>
